module.exports = __webpack_public_path__ + "static/media/infoJumbo1.6be0466c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/gressel/images/infoJumbo1.png
// module id = 539
// module chunks = 0